import { COLORS_TO_BE_REVIEWED } from "components-redesign/styles/colors";
import { FlexContent } from "components/FlexContent/FlexContent";
import { ReactComponent as CampaignIcon } from "icons/changeHistory/campaign.svg";
import { ReactComponent as CreativeIcon } from "icons/changeHistory/creative.svg";
import { ReactComponent as LineitemIcon } from "icons/changeHistory/lineitem.svg";
import { useSelector } from "react-redux";
import { getAllCampaigns } from "redux/campaigns/selectors";
import { getAllCreativesObject } from "redux/creatives/selectors";
import { ChangeHistoryRow } from "../types";
import { Tooltip } from "components-redesign/Tooltip/Tooltip";

const ENTITY_ICON_MAP = {
  Campaign: CampaignIcon,
  Lineitem: LineitemIcon,
  Creative: CreativeIcon,
};

export const EntityCell = ({ row }: { row: ChangeHistoryRow }) => {
  const campaigns = useSelector(getAllCampaigns);
  const creativesObject = useSelector(getAllCreativesObject);
  const firstChange = row.changes[0];
  const EntityIcon = ENTITY_ICON_MAP[firstChange.entityType];

  const getEntityName = () => {
    if (firstChange.entityType === "Campaign") {
      const campaign = campaigns.find((c) => c.id === firstChange.entityId);
      return campaign?.name || firstChange.entityType;
    }

    if (firstChange.entityType === "Lineitem") {
      for (const campaign of campaigns) {
        const lineitem = campaign.lineitems?.find(
          (li) => li.id === firstChange.entityId
        );
        if (lineitem) return lineitem.name;
      }
      return firstChange.entityType;
    }

    if (firstChange.entityType === "Creative") {
      const creative = creativesObject[firstChange.entityId];
      return creative?.name || firstChange.entityType;
    }

    return firstChange.entityType;
  };

  const getCampaignForLineitem = () => {
    if (firstChange.entityType !== "Lineitem") return null;

    for (const campaign of campaigns) {
      const lineitem = campaign.lineitems?.find(
        (li) => li.id === firstChange.entityId
      );
      if (lineitem) return campaign;
    }
    return null;
  };

  const parentCampaign = getCampaignForLineitem();

  return (
    <div>
      <Tooltip title={getEntityName()}>
        <div>
          <FlexContent
            align="center"
            gap="10px"
            style={{ fontWeight: 500 }}>
            <EntityIcon />
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
              }}>
              {getEntityName()}
            </div>
          </FlexContent>
        </div>
      </Tooltip>

      <div
        style={{
          fontSize: "12px",
          color: COLORS_TO_BE_REVIEWED.anotherLightGray,
        }}>
        {firstChange.entityId}
      </div>

      {parentCampaign && (
        <Tooltip title={parentCampaign.name}>
          <div>
            <FlexContent
              align="center"
              gap="4px"
              style={{ fontWeight: 500, fontSize: "10px" }}>
              <CampaignIcon width="10px" />
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "200px",
                }}>
                {parentCampaign.name}
              </div>
            </FlexContent>
          </div>
        </Tooltip>
      )}
    </div>
  );
};
